/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Services from './services';
import fetch from '../../core/fetch';
import ServicesLayout from '../../components/ServicesLayout';
import { gqlRequest } from '../../actions/intl';
import _ from 'lodash';

/*
    Fetch that consumes API_URL env and additional url directories
    basically this is fetch for
    ${process.env.API_URL}/eservices/external/................url part

    we should use this technique more often !!!!!!!!!!!!
*/
const extServiceFetch = (url, rest) => fetch(`${process.env.API_URL}/eservices/external${url}`, ...rest);

export default {

  path: '/services',

  async action(req) {
    const { query, store } = req;

    /* check if query has all required keys, WE'RE SO FUNCTIONAL :) */
    if (!_.every(['customerId', 'district', 'serviceType'],_.partial(_.has, query))) return { redirect: '/notFound', tekst: { abc: 'sldkfjsddf' }};

    /* check if it is valid service */
    const validServiceTypes = ['WypisIWyrysZMpzp', 'ZaswiadczenieMPZP', 'wypis_i_wyrys', 'uproszczony_wypis']
    if ( !_.includes(validServiceTypes, query.serviceType) ) return { redirect: '/notFound', tekst: { abc: 'sldkfjsddf' }};

    /* Fetch district precints */
    const odp = await fetch(`${process.env.API_URL}/eservices/${query.district}/precints`, { method: 'GET' })
                      .then(r => r.status === 200 ? r.json(): null)
                      .then(resp => resp ? resp.obreby : null);

    /* Fetch eboi user */
    const eboiUser = await extServiceFetch(`/${query.district}/getcustomer?customerId=${query.customerId}`, { method: 'GET' })
                           .then(r => r.status === 200 ? r.json(): null );

    /* Fetch starting bounding box */
    const boundingBox = await fetch(`${process.env.API_URL}/mapstates/${query.district}`, {method: 'GET' })
                              .then(r => r.status === 200 ? r.json(): null);

    /* Fetch app district */
    /* Fetch starting bounding box */
    const appDistrict = await fetch(`${process.env.API_URL}/app_district/${query.district}`, {method: 'GET' })
                              .then(r => r.status === 200 ? r.json(): null);

    if (eboiUser) {
      return {
        title: "WODGiK - e-Usługi",
        component: <ServicesLayout user={eboiUser}><Services {...boundingBox} {...appDistrict} {...query} obreby={odp} userInfo={eboiUser} /></ServicesLayout>,
        description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
      };
    } else {
      return { redirect: '/notFound', tekst: { abc: 'sldkfjsddf' }}
    }
  },
};


// const path = `${process.env.API_URL}/eservices/external/${query.district}/getcustomer?customerId=${query.customerId}`;
// const eboiUser = await fetch(path, { method: 'GET' }).then(r => r.status === 200 ? r.json(): null );



// WEBPACK FOOTER //
// src/routes/services/index.js